import { render, staticRenderFns } from "./info_personasencu.vue?vue&type=template&id=032f78e9"
import script from "./info_personasencu.vue?vue&type=script&lang=js"
export * from "./info_personasencu.vue?vue&type=script&lang=js"
import style0 from "./info_personasencu.vue?vue&type=style&index=0&id=032f78e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports